module.exports = __webpack_public_path__ + "img/ic_spo2@2x.e6a968a2.png";